import React from "react"
import styled from "styled-components"
import Image from "next/image"
import NEWS_LIST from "./newsList"
import useInject from "~/hooks/useInject"

const FeaturedInContainer = styled.div`
  z-index: 1;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  background-color: ${(props) => (props.homepage ? "none" : "white")};
  padding: 1rem;
  width: 100%;
`

const TitleContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 18px;
`

const Title = styled.div`
  font-size: 18px;
  font-weight: bold;
`

const ImageContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
`

const ItemContainer = styled.a`
  padding: 0.6rem 1.2rem 0.6rem 1.2rem;
  transition: all 0.5s ease;
  position: relative;
  :hover {
    filter: drop-shadow(4px 4px 4px #c0c0c0);
    opacity: 0.8;
  }
  ${(props) => props.theme.media.mobile`
    padding: 0.3rem 0.6rem 0.3rem 0.6rem;
  `}
`

const LogoWrapper = styled.div`
  position: relative;
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
`


const mapStore = (store) => ({
  isStateAffiliatedWithWinitLawLookup: store.trafficLookup.isStateAffiliatedWithWinitLaw,
  isStateAffiliatedWithWinitLawSubmission: store.trafficSubmission.isStateAffiliatedWithWinitLaw,
})
const FeaturedInLogo = ({ homepage }) => {
  const { isStateAffiliatedWithWinitLawLookup, isStateAffiliatedWithWinitLawSubmission } = useInject(mapStore)
  return (!isStateAffiliatedWithWinitLawLookup && !isStateAffiliatedWithWinitLawSubmission) ? (
    <FeaturedInContainer homepage={homepage}>
      <TitleContainer>
        <Title>WinIt, Inc. has been featured in the following articles:</Title>
      </TitleContainer>
      <ImageContainer>
        {NEWS_LIST.map((item) => (
          <ItemContainer
            href={item.linkHref}
            target="_blank"
            rel="noopener noreferrer"
            key={item.name}
          >
            <LogoWrapper width={item.width} height={item.height}>
              <Image src={item.imgSrc} alt={item.name} layout="fill" />
            </LogoWrapper>
          </ItemContainer>
          ))}
      </ImageContainer>
    </FeaturedInContainer>
  ) : null
}

export default FeaturedInLogo
